import { put, takeEvery } from 'redux-saga/effects';
import Actions from '../monthwise-action';

export function* monthwiseDepartmentService() {
	try {
		// Department API removed - HR module requires subscription check
		yield put(Actions.creators.getMonthWiseDepartmentSuccess([]));
	} catch (err) {
		yield put(Actions.creators.getMonthWiseDepartmentFail(err));
	}
}

export default function* salaryMonthWiseWatcher() {
	yield takeEvery(Actions.types.GET_MONTHWISE_DEPARTMENT_START, monthwiseDepartmentService);
}
